<script setup>
import { computed } from 'vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { MailCheck } from 'lucide-vue-next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';

const props = defineProps({
    status: String,
});

const form = useForm();

const submit = () => {
    form.post(route('verification.send'));
};

const verificationLinkSent = computed(() => props.status === 'verification-link-sent');
</script>

<template>
    <Head title="Xác minh email" />

    <div class="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-md">
            <CardHeader class="items-center space-y-3 text-center">
                <div class="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
                    <MailCheck class="h-6 w-6" />
                </div>
                <CardTitle class="text-2xl">Xác minh email</CardTitle>
                <CardDescription>
                    Vui lòng xác minh email bằng cách bấm vào liên kết chúng tôi vừa gửi cho bạn.
                    Nếu chưa nhận được, chúng tôi sẽ gửi lại một liên kết mới.
                </CardDescription>
            </CardHeader>

            <CardContent>
                <div v-if="verificationLinkSent" class="mb-4 rounded-md bg-green-50 px-3 py-2 text-center text-sm font-medium text-green-700">
                    Một liên kết xác minh mới đã được gửi tới email của bạn.
                </div>

                <form @submit.prevent="submit">
                    <Button
                        type="submit"
                        class="w-full"
                        :class="{ 'opacity-50': form.processing }"
                        :disabled="form.processing"
                    >
                        Gửi lại email xác minh
                    </Button>
                </form>

                <div class="mt-6 flex items-center justify-center gap-4 text-sm text-muted-foreground">
                    <Link :href="route('profile.show')" class="hover:text-primary hover:underline">
                        Chỉnh sửa hồ sơ
                    </Link>
                    <Link :href="route('logout')" method="post" as="button" class="hover:text-primary hover:underline">
                        Đăng xuất
                    </Link>
                </div>
            </CardContent>
        </Card>
    </div>
</template>
